import React from "react"

import * as S from "./contact-hero.styles"
import parse from "html-react-parser"

const ContactHero = ({ title, description, bgImage, bgColor }) => {
  return (
    <S.Section>
      <S.BgImage alt={title} img={bgImage} bgcolor={bgColor} />
      <S.Wrapper maxWidth="xl">
        <S.TextWrapper>
          <S.Title>{title}</S.Title>
          {description && <S.Description>{parse(description)}</S.Description>}
        </S.TextWrapper>
      </S.Wrapper>
    </S.Section>
  )
}
export default ContactHero
